import styled from 'styled-components';
import { Text } from '../Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledTopContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	gap: 10px;
	align-items: center;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: 0.75;
	}

	${Text} {
		&:first-of-type {
			font-weight: 400;
			font-size: 16px;
			color: rgba(255, 255, 255, 0.75);
		}

		&:last-of-type {
			font-size: 14px;
			font-weight: 400;
			color: rgba(255, 255, 255, 0.5);

			span {
				font-size: 16px;
				font-weight: 500;
				color: #ffffff;
			}
		}
	}
`;

const StyledListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 380px;
	height: 577px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledButtonContainer = styled.div`
	position: relative;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	img {
		width: 11px;
	}
`;

export {
	StyledListContainer,
	StyledContainer,
	StyledTopContainer,
	StyledButtonContainer,
	StyledButtonContent,
};
